import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxHeight: 16,
  viewboxWidth: 16,
};

export default ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => (
  <SVGLoader
    viewboxHeight={viewboxHeight}
    viewboxWidth={viewboxWidth}
    {...rest}
  >
    <path d="M9.49999 3.66675H0.833323C0.465133 3.66675 0.166656 3.96522 0.166656 4.33341V11.6667C0.166656 12.0349 0.465133 12.3334 0.833323 12.3334H9.49999C9.86818 12.3334 10.1667 12.0349 10.1667 11.6667V4.33341C10.1667 3.96522 9.86818 3.66675 9.49999 3.66675Z" />
    <path d="M15.6733 4.04678C15.6247 4.01869 15.5695 4.00391 15.5133 4.00391C15.4571 4.00391 15.402 4.01869 15.3533 4.04678L11.3533 6.04678C11.2977 6.07488 11.2509 6.11772 11.218 6.17063C11.185 6.22353 11.1673 6.28447 11.1667 6.34678V9.68011C11.1616 9.74372 11.1746 9.80745 11.204 9.86404C11.2335 9.92063 11.2783 9.96778 11.3333 10.0001L15.3333 12.0001C15.3844 12.0232 15.4403 12.0333 15.4962 12.0296C15.5521 12.0258 15.6062 12.0083 15.6537 11.9787C15.7012 11.949 15.7406 11.908 15.7684 11.8594C15.7963 11.8108 15.8117 11.7561 15.8133 11.7001V4.33344C15.8146 4.27794 15.8026 4.22294 15.7783 4.17305C15.7539 4.12316 15.7179 4.07986 15.6733 4.04678Z" />
  </SVGLoader>
);
